/**
 *
 * @param initialDate
 * @param value
 */
export const addDays = (initialDate: Date, value: number) => {
  const date = new Date(initialDate.getTime());

  date.setDate(date.getDate() + value);

  return date;
};

/**
 *
 * @param initialDate
 * @param value
 */
export const subtractDays = (initialDate: Date, value: number) => {
  const date = new Date(initialDate.getTime());

  date.setDate(date.getDate() - value);

  return date;
};

/**
 *
 * @param initialDate
 * @param value
 */
export const addWeeks = (initialDate: Date, value: number) => {
  const date = new Date(initialDate.getTime());

  date.setDate(date.getDate() + value * 7);

  return date;
};

/**
 *
 * @param initialDate
 * @param value
 */
export const subtractWeeks = (initialDate: Date, value: number) => {
  const date = new Date(initialDate.getTime());

  date.setDate(date.getDate() - value * 7);

  return date;
};

/**
 *
 * @param initialDate
 * @param value
 */
export const addMonths = (initialDate: Date, value: number) => {
  const date = new Date(initialDate.getTime());

  date.setMonth(date.getMonth() + value);

  return date;
};

/**
 *
 * @param initialDate
 * @param value
 */
export const subtractMonths = (initialDate: Date, value: number) => {
  const date = new Date(initialDate.getTime());

  date.setMonth(date.getMonth() - value);

  return date;
};

/**
 *
 * @param initialDate
 * @param value
 */
export const addYears = (initialDate: Date, value: number) => {
  const date = new Date(initialDate.getTime());

  date.setFullYear(date.getFullYear() + value);

  return date;
};

/**
 *
 * @param initialDate
 * @param value
 */
export const subtractYears = (initialDate: Date, value: number) => {
  const date = new Date(initialDate.getTime());

  date.setFullYear(date.getFullYear() - value);

  return date;
};

/**
 * Our portfolio APIs require bid / ask expiration to have
 * a specific ISO-8601 format in order to pass validation.
 *
 * @param {Date} initialDate
 * @returns {string} - '2022-11-18T13:42:39+0000'
 */
export const formatPortfolioItemExpiration = (initialDate: Date) =>
  `${initialDate.toISOString().split('.')[0]}+0000`;
